import { IEvent } from "../../../../models/Event"
import React from "react";

export const Medical: React.FC<{ event: IEvent }> = ({ event }) => {
    return (
        <div className="terms-container">
            <h2 className="panel-title">הצהרת בריאות</h2>
            <div className="panel-actions">
                {event.medicalLinks && event.medicalLinks.map(link =>
                    <a className="btn btn-outline" href={link.link} key={link.link} target="_blank" rel="noreferrer">{link.name}</a>
                )}
            </div>
        </div>
    )
}
